import { withTranslation } from 'react-i18next';
import { t } from "../../hooks/useAppTranslation";
/* eslint-disable no-unused-expressions */
import React from 'react';
import {store} from '../../Redux/Store/Store';
import * as actions from '../../Redux/Actions/Controls';
import * as actionsProg from '../../Redux/Actions/Programs';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import * as PropertyBucket from '../../Properties/Properties';
import {SimpleDocumentsListWithFetch} from '../documents';
import * as ControlFunctions from '../ManageControlCommons/ManageControlCommons';
import {Waiter} from '../WaitingSign/Waiting';
import PopUp from '../PopUp/PopUp';
import SelectCustom from '../SelectCustom/SelectCustom';
import {getTablePageBaseOnControlNumber, getTablePageBaseOnPageNumber} from '../../Helpers/utils';
import {hasPermission} from "../ControlStateHelper";
import TableCustomLazyLoading from "../TableCustom/TableCustomLazyLoading";
import * as httpService from '../HttpService/HttpService';
import {cloneDeep} from "lodash";

// export const GET_CONTROL_DATA_REQUESTED = 'GET_CONTROL_DATA_REQUESTED';
// export const GET_CONTROL_DATA_DONE = 'GET_CONTROL_DATA_DONE';
// export const GET_CONTROL_DATA_FAILED = 'GET_CONTROL_DATA_FAILED';

class ManageControlPlanned extends React.Component {

	previousInputFocusId = null;

	constructor(props) {
		super(props);
		this.state = {
			showDeleteTab: false,
			showPopup: false,
			showDocumentsControl: null,
			isWaiting: false,
			tablePageSize: 10,
			page: this.props.match.params.pageNumber ? parseInt(this.props.match.params.pageNumber) - 1 : 0,
			programSearch: "",
			quickSearch: "",
			filter: [],
			orderBy: "number",
			orderById: "",
			orderDirection: "asc",
			filterChangeOnField: null,
			documentTitle: 'e-Kontrole | Kontrole rejestrowane',
			columns: []
		};
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
	}

	getColumnsDefault() {
		return [
			{title: t("external-controls-control-number"), field: 'number', cellStyle: { width: '305px', minWidth: '305px' }},
			{title: t("external-controls-control-date"), field: 'plannedDate'},//plannedTerm
			{title: t("external-controls-beneficiary"), field: 'project.beneficiaryName', minWidth: 120},//project.beneficiaryName
			{title: t("external-controls-beneficiary-id"), field: 'project.beneficiaryIdentityNumber', minWidth: 120},//project.beneficiaryIdentityNumber
			{title: t("external-controls-controlled-entity"), field: 'controlledParty', minWidth: 120},//subjectsList
			{title: t("external-controls-controlling-body"), field: 'controllingSubject', minWidth: 120},
			{title: t("external-controls-control-type"), field: 'extType', width: 120},//type
			{title: t("external-controls-control-result"), field: 'result', width: 120},
		];
	}

	updateColumns = () => {
		this.setState({
			columns: this.getColumnsDefault()
		});
	};

	componentDidMount() {
		document.title = "e-Kontrole | Kontrole rejestrowane";

		const newState = cloneDeep(this.state);

 		newState.columns = this.getColumnsDefault();
		if (this.props.controls.tableFilters.length && this.props.controls.tableName === document.title) {
			newState.columns = this.getDefaultFilters();
			newState.filter = this.props.controls.tableFilters;
		}
		if (this.props.controls.tableQuickSearch && this.props.controls.tableName === document.title) {
			newState.quickSearch = this.props.controls.tableQuickSearch;
		}
		if(this.props.match.params.pageNumber) {
			newState.page = parseInt(this.props.match.params.pageNumber) - 1;
		}
		if (store.getState().programs.selected) {
			newState.programSearch = [store.getState().programs.selected];
		}
		this.setState(newState, () => {
			this.fetchData(newState.page, ControlFunctions.getFilterParam(newState.filter), [newState.orderBy, newState.orderDirection], newState.programSearch, newState.quickSearch, newState.tablePageSize, (e) => this.handleRedirect(e));
		});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.programs?.selected?.code !== this.props.programs?.selected?.code) {
			this.setValues([this.props.programs.selected]);
		}
		if (prevProps.i18n.language !== this.props.i18n.language) {
			this.updateColumns();

			this.fetchData(
				0,
				ControlFunctions.getFilterParam(this.state.filter),
				[this.state.orderBy, this.state.orderDirection],
				this.state.programSearch,
				this.state.quickSearch,
				this.state.tablePageSize
			);
		}
	}

	handleRedirect = (e) => {
		if (e.totalPages <= this.state.page) {
			this.setState(
				{
					page: 0
				},
				() => {
					this.props.history.push(`/external_controls_list`);
					this.fetchData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize);
				}
			);
		}
	}

	getDefaultFilters = () => {
		const columns = cloneDeep(this.getColumnsDefault());

		this.props.controls.tableFilters.forEach((filter, index) => {
			if (filter.filterValue) {
				columns[index].defaultFilter = filter.filterValue;
			}
		});

		return columns;
	}

	fetchData = (
		pageParam = this.state.page,
		filterParam = ControlFunctions.getFilterParam(this.state.filter),
		sortParam = [this.state.orderBy, this.state.orderDirection],
		programSearch = this.state.programSearch,
		quickSearch = this.state.quickSearch,
		tablePageSize = this.state.tablePageSize,
		successCallback
	) => {
		const url = PropertyBucket.getExternalControls(this.props.i18n.language);

		this.props.fetchControlData(
			url,
			pageParam,
			filterParam,
			sortParam,
			programSearch,
			quickSearch,
			tablePageSize,
			successCallback
		);
	};

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	setValues = (values) => {
		this.setState(
			{
				programSearch: values,
				page: 0
			},
			() => {
				this.props.history.push(`/external_controls_list`);
				this.fetchData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], values, this.state.quickSearch, this.state.tablePageSize);
			}
		)
	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	showPopup = (title, notification, type, onClickEvent) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type, onClickEvent: onClickEvent}
		})
	};

	onDetailButtonClick = (row) => {
		this.props.history.push('/external_control/external_control_detail/' + row.id);
	};

	prepareData = (data) => {
		return data?.map(ControlFunctions.getExternalControlData);
	};

	focusOnFilterElement(_this) {
		const field = _this.state.filter.find(x => {
			if (this.state.filterChangeOnField) {
				return x.field === this.state.filterChangeOnField.field;
			} else {
				return x.filterValue !== undefined;
			}
		});

		if (field) {
			const elements = document.getElementsByClassName('MuiInput-inputTypeSearch');
			let findInputToFocus = false;

			for (let i = 0; i < elements.length; i++) {
				if (elements[i].value.length && elements[i].value === field.filterValue) {
					elements[i].focus();
					findInputToFocus = true;
					this.previousInputFocusId = i;
				}
			}

			if (!findInputToFocus && field.filterValue === '' && this.previousInputFocusId != null) {
				elements[this.previousInputFocusId].focus();
				this.previousInputFocusId = null;
			}
		}
	}

	isDisabledEdit = (data) => {
		return !hasPermission(data,"external.control.edit");
	};

	isDisabledCopy = (data, userRole) => {

		if (userRole === 'O') {
			return true;
		}

		return false;
	};

	handlePageChange(page, size) {
		this.setState({page: parseInt(page) })
		this.fetchData(page, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, size);
	}

	handleFilterChange(filter) {
		this.state.filter.forEach((filterField, id) => {
			if (filterField.filterValue !== filter[id].filterValue) {
				this.setState({ filterChangeOnField: filter[id] });
			}
		});

		this.setState(
			{
				page: 0,
				filter: filter
			},
			() => {
				this.props.history.push(`/external_controls_list`);
				const {setFiltersData} = this.props;
				setFiltersData({ filter, tableName: this.state.documentTitle });
				this.fetchData(0, ControlFunctions.getFilterParam(filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize, () => this.focusOnFilterElement(this));
			}
		);
	}

	handleQuickSearchChange(search) {
		this.setState({quickSearch: search, page: 0},
			() => {
				this.props.history.push(`/external_controls_list`);
				const {setQuickSearchData} = this.props;
				const focusOnQuickSearchInput = () => {
					const element = document.querySelector(`[placeholder=${t('table-search')}]`);
					element.focus();
				};
				setQuickSearchData({ quickSearch: search, tableName: this.state.documentTitle });
				this.fetchData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, search, this.state.tablePageSize, focusOnQuickSearchInput);
			}
		);
	}

	handleOrderChange(column, order) {
		const orderColumn = (this.state.columns[column] ? this.state.columns[column].field : '');

		this.setState(
			{
				page: 0,
				orderById: column,
				orderBy: orderColumn,
				orderDirection: order
			},
			() => {
				this.props.history.push(`/external_controls_list`);
				this.fetchData(0, ControlFunctions.getFilterParam(this.state.filter), [orderColumn, order], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize);
			}
		);
	}

	onDeleteButtonClick = (row) => {
		this.showPopup(t("g-notification"), `${t("external-controls-dialog-remove-control")} ${row.number}?`, 'confirm', () => {
			this.deleteControl(row)
		})
	};

	isDisableDelete = (data, userRole) => {
		return userRole !== 'SA' || !hasPermission(data, "control.manage.delete");
	};

	deleteControl = (record) => {
		this.isWaitingOnOff(true);
		let controlId = record.id;
		let url = PropertyBucket.deleteControl(controlId);
		let callPromise = httpService.getService(url, 'DELETE', null);
		let _this = this;

		callPromise.then(
			function (message) {
				_this.fetchData(0, ControlFunctions.getFilterParam(_this.state.filter), [_this.state.orderBy, _this.state.orderDirection], _this.state.programSearch, _this.state.quickSearch, _this.state.tablePageSize);
				_this.isWaitingOnOff(false);
				_this.showPopup(t("g-notification"), t('external-controls-dialog-control-removed'), 'notify')
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup(t("g-error"), error.message ? error.message : error, 'error')
			}
		)
	};

	render() {
		const userRole = localStorage.getItem('userRole');
		const controlNr = new URLSearchParams(this.props.history.location.search).get('number');
		const loadedControlsData = this.state.loadedControlsData ? this.state.loadedControlsData : store.getState().controls.controls;
		const loadedProgsData = userRole === 'SA' ? store.getState().programs.programs : null;
		let table;
		let dropdown;
		let popUp;
		this.state.showPopup ?
			(popUp = <PopUp type={this.state.popUp.type}
			                title={this.state.popUp.title}
			                notification={this.state.popUp.notification}
			                link={this.state.popUp.link}
			                onClickEvent={this.state.popUp.onClickEvent}
			                closePopUp={this.handleClosePopUp}
			/>) : null;

		if (this.props.controls && this.props.controls.isLoading === false) {
			if (loadedControlsData.length >= 0) {
				let totalElements = 0
				if (loadedControlsData.length > 0) {
					totalElements = this.props.controls.filters.totalElements
				}
				this.prepareData(loadedControlsData);

				table = <TableCustomLazyLoading
					columns={this.state.columns}
					data={loadedControlsData}
					orderBy={this.state.orderById}
					orderDirection={this.state.orderDirection}
					count={totalElements}
					page={this.state.page}

					actions={[
						rowData => ({
							icon: 'library_books',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>{t("external-controls-control-details")}<span className='sr-only'> {t('external-controls-for-control')}: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onDetailButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'delete',
							iconProps: {
								style: {
									fontSize: '24px',
									color: this.isDisableDelete(rowData, userRole) ? '#ccc' : '#0d47a1'
								}
							},
							tooltip: <span>{t("g-delete")} <span
								className='sr-only'> {t('external-controls-control')}: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onDeleteButtonClick(rowData);
							},
							disabled: this.isDisableDelete(rowData, userRole)
						}),
						rowData => ({
							icon: 'editButton',
							iconProps: {style: {fontSize: '24px', color: this.isDisabledEdit(rowData) ? '#ccc' : '#0d47a1'}},
							tooltip: <span>{t("g-edit")}<span className='sr-only'> {t('external-controls-for-control')}: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.props.history.push(`/external_controls/edit/${rowData.id}`)

							},
							disabled: this.isDisabledEdit(rowData, userRole)
						}),
						rowData => ({
							icon: 'folder',
							iconProps: {style: {fontSize: '24px', color: '#0d47a1'}},
							tooltip: <span>{t("g-files")}<span className='sr-only'> {t('external-controls-for-control')}: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.setState({showDocumentsControl: rowData});
							},
						}),
						rowData => ({
							icon: 'add_to_photos',
							iconProps: {style: {fontSize: '24px', color: '#0d47a1'}},
							tooltip: <span>{t("external-controls-create-copy")}<span className='sr-only'> {t('external-controls-for-control')}: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.showPopup(t("external-controls-dialog-creating-copy-control"), t("external-controls-dialog-create-copy-control"), 'confirm', () => {
										this.props.history.push(`/external_controls/copy/${rowData.id}`)
							})},
							disabled: this.isDisabledCopy(rowData, userRole)
						})
					]}
					initialPage={controlNr ?
						getTablePageBaseOnControlNumber({
							controlNr,
							pageSize: 10, // initial PageSize currently is always 10
							list: loadedControlsData,
						}) :
						getTablePageBaseOnPageNumber(
							this.props.match.params.pageNumber,
							10, // initial PageSize currently is always 10
							loadedControlsData
					)}
					pageSize={this.state.tablePageSize}
					onChangePage={
						(page, size) => {
							this.props.history.push(`/external_controls_list/${parseInt(page) + 1}`)
							this.setState({page: parseInt(page)})
							this.setState({tablePageSize: parseInt(size)})
							this.handlePageChange(parseInt(page), parseInt(size))
						}
					}
					onFilterChange={(value) => {
						this.handleFilterChange(value)
					}}
					onQuickSearchChange={(value) => {
						this.handleQuickSearchChange(value)
					}}
					quickSearch={this.state.quickSearch}
					onOrderChange={(column, order) => {
						this.handleOrderChange(column, order)}
					}

					onChangeRowsPerPage={
						(pageSize) => this.setState({tablePageSize: pageSize})
					}
				/>;
			}
		}

		if (userRole === 'SA' && loadedProgsData.length > 0) {
			dropdown = <div id='progs_select'>
				<SelectCustom
					labelField='code'
					placeholder={t('external-controls-programmes')}
					valueField='code'
					options={loadedProgsData}
					onChange={(values) => this.setValues(values)}
					searchFn={(selectProps) => {
						if (selectProps.state.search !== this.state.previousSearch) {
							const checkOptionCode = selectProps.props?.options?.find(spec => spec.code.toUpperCase().includes(selectProps.state?.search.toUpperCase()));
							if (!checkOptionCode) {
								selectProps.state['search'] = this.state.previousSearch;
								this.setState({});
							} else {
								this.setState({
									previousSearch: selectProps.state.search
								})
							}
						}
					}}
					multi
					isMulti
					id='programmsMyControlActiveSelectId'
					dropdownId='programmsMyControlActiveDropdownId'
					label={t('external-controls-programmes')}
					parentRef={this.programmsMyControlActiveSelectRef}
				/>
			</div>
		}

		const { showDocumentsControl: control } = this.state;
		return (
			<div id='control_search'>
				{popUp}
				{control !== null &&
					<SimpleDocumentsListWithFetch
						controlUuid={control.uuid}
						inPopup
						onCancel={() => this.setState({showDocumentsControl: null})}
					/>
				}
				<div id='add_control'>
					<h2 className='mb-4 float-left'>{t("g-review-controls")}</h2>
					{(userRole === 'K' || userRole === 'SA' || userRole === 'A' || userRole === 'SK') ?
						<Link to='/external_control/create' className='btn save-btn' id='plus_img_container'><i data-v-db6946bc=''
																												aria-hidden='true'
																												className='v-icon material-icons theme--light v-list-text'>add</i><span className='uppercase'>{t("g-register-control")}</span></Link>
						: null
					}
					<div className='clearfix'/>
				</div>
				<div>
					{userRole === 'SA' ? dropdown : null}
					<div id='controls_table'>
						{table}
					</div>
				</div>
				<div id='waiter'><Waiter loading={this.state.isWaiting || this.props.controls.isLoading}/></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch, ownParams) => {
	let page = 0;
	if(ownParams.match.params.pageNumber) {
		page = (ownParams.match.params.pageNumber-1)
	}

	return {
		fetchControlData: (url, pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, successCallback) => dispatch(actions.getControlData(url, page, pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, undefined, successCallback)),
		setFiltersData: (filters) => dispatch(actions.setFiltersData(filters)),
		setQuickSearchData: (quickSearch) => dispatch(actions.setQuickSearchData(quickSearch)),
	}
};
export const ExternalControlsProvider = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ManageControlPlanned))
